import { DateTime } from 'luxon'

import { queryClient } from '../queryClient'
import type { PagedResult } from '../DTOs/Common/PagedResult'
import type { StoppageCalc } from '../DTOs/Stoppage/StoppageCalc'

const BASE = DateTime.fromISO('1900-01-01', { zone: 'utc' })

export function describeShiftId(shiftId: number | undefined): string | undefined {
  if (!shiftId || !Number.isFinite(shiftId)) return undefined

  const days = Math.floor(shiftId / 10)
  const shiftNumber = shiftId % 10
  const date = BASE.plus({ days })
  if (!date.isValid) return undefined

  const shift = shiftNumber === 1 ? 'Day' : shiftNumber === 2 ? 'Afternoon' : shiftNumber === 3 ? 'Night' : null
  return shift ? `${date.toISODate()} ${shift} shift` : date.toISODate() ?? undefined
}

export function cachedMachineName(plantId: number | undefined): string | undefined {
  if (!plantId) return undefined

  for (const [, cached] of queryClient.getQueriesData<PagedResult<StoppageCalc>>({
    queryKey: ['dataTable', 'operations', 'stoppageCalcs'],
  })) {
    for (const row of cached?.data ?? []) {
      if (row?.plantId === plantId && row.machineName) return row.machineName
    }
  }
  return undefined
}
